import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-label',
    templateUrl: './label.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LabelComponent implements OnInit {
  @Input() items?: any;
  @Input() inverse?: string;

  constructor() {}

  ngOnInit() {}
}
